import { Expression } from './Expression.js';
export class IfExpression extends Expression {
    constructor(condition, _then, _else) {
        super();
        this.condition = condition;
        this._then = _then;
        this._else = _else;
    }
    getCondition() {
        return this.condition;
    }
    getThenExpression() {
        return this._then;
    }
    getElseExpression() {
        return this._else;
    }
    evaluate(visitor, localVariables) {
        return this.getCondition().evaluate(visitor, localVariables)
            ? this.getThenExpression().evaluate(visitor, localVariables)
            : this.getElseExpression().evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=IfExpression.js.map